import axios from 'axios';
import * as responseFormatInterceptor from '../interceptors/response-format';
import { Toast } from 'vant';
import { userLogin } from '@/widget/index';
let defaultConfig = {
    timeout: 1000 * 60,
    credentials: true,
    headers: {
        Accept: 'application/json',
        Authorization: ''
    }
};
/**
 * axios工厂方法
 *
 * @export
 * @param {AxiosRequestConfig} [config={}]
 * @returns
 */
export function generator(config = {}) {
    const instance = axios.create(Object.assign(defaultConfig, config));
    instance.interceptors.response.use(responseFormatInterceptor.responseInterceptor);
    instance.interceptors.response.use((res) => {
        if (res.code !== 200 && !res.success && res.code !== 6008) {
            Toast(res.message + '【' + res.code + '】');
        }
        return res;
    }, (error) => {
        let msg = error?.message;
        if (error?.message.indexOf('timeout') > -1) {
            Toast('请求超时，请稍后尝试！');
        }
        else if (/(403|401)/g.test(msg)) {
            userLogin();
        }
        else {
            Toast(msg);
        }
    });
    return instance;
}
